export function validateAssetsUtil (assetDetails) {
  const assetErrors = []

  assetDetails?.forEach((asset, index) => {
    const errors = {}

    const {
      serviceInterval,
      startDate,
      serviceDay = [],
      serviceDate,
      serviceDailyFrequency
    } = asset

    if (!serviceInterval) {
      errors.serviceInterval = 'Required'
    }

    if (!startDate) {
      errors.startDate = 'Required'
    }

    if (serviceInterval === 'MONTHLY' && !serviceDate.length) {
      errors.serviceDate = 'Required'
    }

    if (serviceInterval === 'EVERY_X_DAYS') {
      if (!serviceDailyFrequency) errors.serviceDailyFrequency = 'Required'
      if (serviceDailyFrequency < 1) errors.serviceDailyFrequency = 'Value must be at least 1'
    }

    if (serviceInterval === 'WEEKLY' && !serviceDay?.length) {
      errors.serviceDay = 'Required'
    }

    if (Object.keys(errors).length > 0) {
      assetErrors[index] = errors
    }
  })

  return assetErrors.length ? assetErrors : undefined
}

export const dayOptions = [
  { value: 'MONDAY', label: 'Monday' },
  { value: 'TUESDAY', label: 'Tuesday' },
  { value: 'WEDNESDAY', label: 'Wednesday' },
  { value: 'THURSDAY', label: 'Thursday' },
  { value: 'FRIDAY', label: 'Friday' },
  { value: 'SATURDAY', label: 'Saturday' },
  { value: 'SUNDAY', label: 'Sunday' }
]
